export default __webpack_public_path__ + "audios/messageTone.ba22bb33a2d91c5a32e6b94b773e1317.mp3";